import _ from 'lodash';
import React, { useContext, useEffect } from 'react';
import { Checkbox, Icon, Label } from 'semantic-ui-react';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import WrapperVertCols from '../../../global/wrappers/WrapperVertCols';
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext';
import { CreateSportsSeasonContext } from './CreateSeason';
import { CreateSportsContext } from './CreateSports';
import UpDownLabel from '../../../global/components/forms/elements/UpDownLabel';
import { useCreateSportsSeason } from '../useHelpers/useCreateSeasonal';

const CreateSportSeasonTeams = () => {

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { sportsTeams } = district_data ?? {};

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state } = createSportsContext ?? {}
  const { currentSeason_info, teams } = createSports_state ?? {}
  const { latestSeason, sportsKey, _sportsYearAbr, _sportsAbr, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}

  const { getCurrent, ammendSeasonalItem } = useCreateSportsSeason()
  const { sportsData_info, sportsSeason_selected } = getCurrent()
  const { districtTeams, selectedItems } = sportsData_info ?? {}
  const { selectedSectionLevel, seasonals, seasonals_fluid } = sportsSeason_selected ?? {}
  const { sectionCounts, teams: sportSeasonTeams } = seasonals ?? {}

  // createSportsSeaonContext
  const createSportsSeaonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_handlers } = createSportsSeaonContext ?? {}

  const { year } = selectedItems ?? {}

  const {
    levelTeams,
    sportSeasonTeamCount,
  } = seasonals_fluid ?? {}

  const setInit = () => {
    const _teams_district = _.cloneDeep(sportsTeams?.[sportsKey]?.teams);
    const _teams_sport = _.cloneDeep(teams);
    let _sportSeasonTeams = _.cloneDeep(sportSeasonTeams);


    _.forEach(_teams_district, (team_district, tdk) => {
      team_district._selected = _teams_sport[tdk] ? true : false;
    });

    _.forEach(_teams_sport, (team_sport) => {
      team_sport._selected = true;
    });

    if (_sportSeasonTeams) {
      _.forEach(_sportSeasonTeams, (team) => {
        team._selected = true;
      });
    }
  };


  useEffect(() => {
    setInit()
  }, [district_data, teams, sportSeasonTeams]);

  const handle_addTeams = () => setInit()

  const handleClear = (type) => {
    switch (type) {
      case 'districtTeams':
        const _districtTeams = _.cloneDeep(districtTeams)
        _.forEach(_districtTeams, (districtTeam) => {
          districtTeam._selected = false
        })
        createSportsSeason_handlers.handleAmmend_districtTeams(_districtTeams)
        break;
      case 'teams':
        const _sportSeasonTeams = _.cloneDeep(sportSeasonTeams)
        _.forEach(_sportSeasonTeams, (team_sport) => {
          team_sport._selected = false
        })
        ammendSeasonalItem({ key: 'teams', data: _sportSeasonTeams })
        break;
    }
  }

  const handleSelect_team = (type, team) => {
    const _districtTeams = _.cloneDeep(districtTeams)
    const _sportSeasonTeams = _.cloneDeep(sportSeasonTeams)
    switch (type) {
      case 'districtTeams':
        if (!_sportSeasonTeams[team._itemKey]) {
          _sportSeasonTeams[team._itemKey] = team
          _sportSeasonTeams[team._itemKey]._selected = true
          _sportSeasonTeams[team._itemKey]._new = true
          _districtTeams[team._itemKey]._selected = true
        } else {
          const _selected = _sportSeasonTeams[team._itemKey]._selected
          _districtTeams[team._itemKey]._selected = !_selected
          _sportSeasonTeams[team._itemKey]._selected = !_selected
        }
        createSportsSeason_handlers.handleAmmend_districtTeams(_districtTeams)
        ammendSeasonalItem({ key: 'teams', data: _sportSeasonTeams })
        break;
      case 'teams':
        const _selected = _sportSeasonTeams[team._itemKey]._selected
        _districtTeams[team._itemKey]._selected = !_selected
        _sportSeasonTeams[team._itemKey]._selected = !_selected
        createSportsSeason_handlers.handleAmmend_districtTeams(_districtTeams)
        ammendSeasonalItem({ key: 'teams', data: _sportSeasonTeams })
        break;
    }
  }

  const handleArrowClick_team = (type, team) => {
    const _sportSeasonTeams = _.cloneDeep(sportSeasonTeams)
    switch (type) {
      case 'teams':
        const { levelKey, sectionKey } = selectedSectionLevel ?? {}
        _sportSeasonTeams[team._itemKey].levels = levelKey
        _sportSeasonTeams[team._itemKey].sections = sectionKey
        ammendSeasonalItem({ key: 'teams', data: _sportSeasonTeams })
        break;
    }
  }

  const handleUpDown_sectionCount = (propKey, value) => {
    const _levelCounts = _.cloneDeep(sectionCounts)
    _levelCounts[propKey] = value ? value : 0
    ammendSeasonalItem({ key: 'sectionCounts', data: _levelCounts })
  }

  const icon_l = (type) => <Icon name='delete' color={'red'} style={{ float: 'right', marginLeft: '1em' }} onClick={() => handleClear(type)}></Icon>
  const icon_r = (type) => <Icon name='arrow right' style={{ float: 'right', marginLeft: '1em' }} onClick={() => handle_addTeams(type)}></Icon>

  const header_district = (type, count) => <div style={{ display: 'grid', gridTemplateColumns: '1fr auto auto auto', alignItems: 'center' }}>
    <div>{_.startCase(type)}</div>
    {icon_l(type)}
    <Label style={{ float: 'right' }} >{count}</Label>
    {icon_r(type)}
  </div>

  const header_teams = (type, count) => <div style={{ display: 'grid', gridTemplateColumns: '1fr auto auto auto', alignItems: 'center' }}>
    <div>{_.startCase(type)}</div>
    {icon_l(type)}
    <Label style={{ float: 'right' }} >{count}</Label>
  </div>

  const hasDynamicKey = (obj, key) => {
    return _.some(obj, (value, objKey) =>
      objKey === key || (_.isPlainObject(value) && hasDynamicKey(value, key))
    );
  };

  const getParentKeysForKey = (obj, key, parentKeys = []) => {
    // Iterate through the object's keys and values
    return _.some(obj, (value, objKey) => {
      if (objKey === key) {
        // Match found, return the current path
        parentKeys.push(objKey);
        return true;
      } else if (_.isPlainObject(value)) {
        // Continue searching in nested objects
        const found = getParentKeysForKey(value, key, [...parentKeys, objKey]);
        if (found) {
          parentKeys.push(objKey);
          return true;
        }
      }
      return false;
    }) && parentKeys.reverse(); // Reverse to preserve parent-to-child order
  };

  const icon_teams = (allowSelect, type, team) => {

    const { sections, levels } = team ?? {}
    const pks = []
    const hasSelectedLs = team?.sections === selectedSectionLevel?.sectionKey && team?.levels === selectedSectionLevel?.levelKey
    const hasLs = team.levels && team.sections
    let _ls = levels && sections ? levels + '-' + sections : 'NA'
    _ls = _ls.replace('section', '')

    const items = []

    if (allowSelect) {
      items.push(<Label color='black' style={{ float: 'right' }}>{_ls}</Label>)
      if (selectedSectionLevel?.levelKey) {
        const { levelKey, sectionKey } = selectedSectionLevel ?? {}
        const t = levelTeams?.[levelKey]?.[sectionKey]?.[team._itemKey]

        let color = 'blue'
        if (hasLs) { color = 'blue' }
        if (hasSelectedLs) { color = 'green' }

        let icon = 'arrow right'
        if (hasLs) { icon = 'circle outline' }
        if (hasSelectedLs) { icon = 'check circle outline' }

        items.push
          (<div style={{ float: 'right' }}>
            <Icon
              color={color}
              name={icon}
              onClick={() => !t && handleArrowClick_team(type, team)} />
          </div>)
        // return <div style={{ float: 'right' }}><Icon name='arrow right' onClick={() => handleTeamSelect(type, team)} /></div>
      }
    }

    return items
  }

  const listItems = (items, type, allowSelect) =>
    _.map(
      _.sortBy(items, 'name'), // Sort items by the 'name' property
      (team, teamKey) => (
        <div
          key={teamKey} // Add a unique key for each element to avoid React warnings 
        >
          <div><Checkbox toggle checked={team._selected} onClick={() => handleSelect_team(type, team)} /></div>
          <div>{team.name}</div>
          <div className='list-select-right'>
            {icon_teams(allowSelect, type, team)}
          </div>
        </div>
      )
    );

  const list = (items, type, allowSelect) => <div key={type} className='list-select'>
    {listItems(items, type, allowSelect)}
  </div>

  const menu_sectionCount = () => {
    const items = _.map(sectionCounts, (sl, slKey) => {
      return <UpDownLabel propKey={slKey} formData={sectionCounts} handleChange={handleUpDown_sectionCount} buttonSize={'tiny'} float={'left'} />
    })
    return <div>
      {items}
    </div>
  }

  const content_districtTeams = () => <Wrapper
    header={header_district('districtTeams', _.size(districtTeams))}
    content={list(districtTeams, 'districtTeams')}
    wrapperType={wrapperTypes.padded}
  />

  const content_teams = () => <Wrapper
    header={header_teams('teams', sportSeasonTeamCount)}
    content={list(sportSeasonTeams, 'teams', true)}
    wrapperType={wrapperTypes.padded}
  />

  const content_sectionCount = () => <Wrapper
    header={'Section Count'}
    content={menu_sectionCount()}
    wrapperType={wrapperTypes.padded}
  />

  const content_season = () => <WrapperVertCols mvc={3}>
    {districtTeams ? content_districtTeams() : <div>District Teams</div>}
    {sportSeasonTeams ? content_teams() : <div>Teams</div>}
    {content_sectionCount()}
  </WrapperVertCols>

  const wrapper_season = () => <Wrapper
    header={'Teams'}
    content={content_season()}
    wrapperType={wrapperTypes.paddedHeader}
  />

  return wrapper_season()

}

export default CreateSportSeasonTeams